<template>
  <div>
    <Form ref="formInline" :label-width="180">
      <Divider orientation="left"><b>称重设置</b></Divider>
      <Row>
        <Col>
          <FormItem>
            <p slot="label">称重单位设置</p>
            <Select v-model="showUnitValue" style="width:200px" placeholder="请选择称重单位" size="large" @on-change="changeUnitValue">
							<Option v-for="item in unitList" :value="item.id" :key="item.name" :label="item.name">
								<span>{{item.name}}</span>
							</Option>
						</Select>
          </FormItem>
          <FormItem>
            <p slot="label">称重偏差提醒</p>
            <i-switch size="large" true-value="1" false-value="2" v-model="$store.state.softwareSetting.weighingRemind">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
            <div style="color: #c5c8ce">开启后如果称重偏差超过阈值进行提醒</div>
          </FormItem>
          <FormItem v-if="$store.state.softwareSetting.weighingRemind==1">
            <p slot="label">称重偏差阈值</p>
            <span>±</span>
            <InputNumber controls-outside size="large" :min="0" v-model="$store.state.softwareSetting.weighingRemindSize"/>
            <span>%</span>
            <div style="color: #c5c8ce">称重偏差超过± {{$store.state.softwareSetting.weighingRemindSize}}% 进行提醒</div>
            <!--&nbsp; <span>~</span>&nbsp;
            <InputNumber controls-outside size="large" :min="0"/>
            <span>%</span>-->
          </FormItem>
        </Col>
      </Row>
      <Divider orientation="left"><b>分拣设置</b></Divider>
      <Row>
        <Col>
          <FormItem>
            <p slot="label">分拣商品设置</p>
            <RadioGroup button-style="solid" type="button" size="large" v-model="$store.state.softwareSetting.skuGroupType">
              <Radio :label="1">按单个SKU分拣</Radio>
              <Radio :label="2">按SPU聚合分拣</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem>
            <p slot="label">自动打印分拣标签</p>
            <i-switch size="large" true-value="1" false-value="2" v-model="$store.state.softwareSetting.autoPrint">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
            <div style="color: #c5c8ce">分拣完成自动打印分拣标签</div>
          </FormItem>
          <FormItem>
            <p slot="label">已分拣数据后移</p>
            <i-switch size="large" :true-value="1" :false-value="2" v-model="$store.state.softwareSetting.sortingMoved">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
            <div style="color: #c5c8ce">开启后，计重商品分拣、不计重商品分拣按客户分拣列表已分拣的数据排在最后</div>
          </FormItem>
          <FormItem
            v-if="this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes('packingBox')">
            <p slot="label">装箱设置</p>
            <i-switch size="large" :true-value="1" :false-value="2" v-model="$store.state.softwareSetting.openBox">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
          </FormItem>
          <FormItem v-if="$store.state.softwareSetting.openBox==1" :label-width="460">
            <p slot="label">装箱后自动打印箱签</p>
            <i-switch size="large" :true-value="1" :false-value="2" v-model="$store.state.softwareSetting.autoPrintBoxLabel">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
            <div style="color: #c5c8ce">整件装箱完成后自动打印箱签</div>
          </FormItem>
          <FormItem v-if="$store.state.softwareSetting.openBox==1" :label-width="460">
            <p slot="label">散件商品分拣后自动标记装箱任务</p>
            <i-switch size="large" :true-value="1" :false-value="2" v-model="$store.state.softwareSetting.autoPartBoxTask">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
            <div style="color: #c5c8ce">按订单分拣时，散件装箱商品分拣后自动添加到装箱任务</div>
          </FormItem>
          <FormItem v-if="$store.state.softwareSetting.openBox==1" :label-width="460">
            <p slot="label">整件商品分拣后自动装箱</p>
            <i-switch size="large" :true-value="1" :false-value="2" v-model="$store.state.softwareSetting.autoWholeBox">
              <span slot="open">开</span>
              <span slot="close">关</span>
            </i-switch>
            <div style="color: #c5c8ce">整件装箱商品分拣后自动完成装箱</div>
          </FormItem>
        </Col>
      </Row>
      <!--<Row>
          <Col :xxl="10" :sm="20" :lg="16" :xl="14">
              <FormItem>
                  <Button type="primary" @click="savePrint()" long size="large">保存</Button>
              </FormItem>
          </Col>
      </Row>-->
    </Form>
    <div style="height: 100px;">
      <div class="bottomOperationBoxWrapper">
        <div class="bottomOperationBox">
          <Button type="primary" @click="saveSortingSetting" long size="large" style="width: 50%;">保存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {queryPrintTemplateList} from '@/api/sorting/sorting';
  import {saveSortingSetting} from "@/api/system/settings";

  export default {
    name: "softwareSetting",
    data() {
      return {
        loading: false,
        showUnitValue: null,
        //称重单位列表
			  unitList: [
				  { name: '市斤', id: 1 },
				  { name: '公斤', id: 2 },
			  ],
      };
    },
    methods: {
      changeUnitValue(data) {
        if(data) {
          this.$emit("changeUnitValue", data)
        }
      },
      // 查询模板数据
      queryPrintTemplateList() {
        queryPrintTemplateList({rows: 100}).then(data => {
          if (data.data.code == 1200) {
            this.printTemplateList = data.data.data.rows;
          } else {
            this.$Message.error(data.data.msg)
          }
        })
      },
      // 查询模板数据
      saveSortingSetting() {
        saveSortingSetting({softwareSetting: this.$store.state.softwareSetting}).then(data => {
          if (data.data.code == 1200) {
            this.$Message.success("保存成功");
          } else {
            this.$Message.error(data.data.msg)
          }
        })
      },
      // 初始化页面
      initPage() {
      },
    },
    mounted() {
      console.log(localStorage.getItem("unitValue"))
      let unit = localStorage.getItem("unitValue") ? Number(localStorage.getItem("unitValue")) : 1
      this.showUnitValue = unit
    },
    /*watch: {
        // 监听路由变化
        $route(to, from) {
            this.$destroy(); // 销毁页面
        }
    }*/
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/components/softwareSetting.vue